import FormElement from './form-element.js';

class OptionLists extends FormElement {
	#container;
	#elements = {};

	constructor(container) {
		super();

		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;

		this.#init();
	}

	#init() {
		const lists = Array.from(this.#container.querySelectorAll('.option-list'));

		for (const list of lists) {
			const links = Array.from(list.getElementsByTagName('a'));
			const multiple = !!+list.dataset.multiple;
			const name = list.dataset.name;
			const active = Array.from(list.getElementsByClassName('active'));

			this.#elements[ name ] = list;

			if (multiple) {
				super.store(name, active.map(li => li.dataset.value));
			} else {
				super.store(name, active[0]?.dataset.value);
			}

			for (const link of links) {
				link.addEventListener('click', e => {
					e.preventDefault();

					const value = link.parentElement.dataset.value;

					if (multiple) {
						this.toggle(name, value);
					} else {
						this.set(name, value);
					}
				});
			}
		}
	}

	set(name, value, ... args) {
		return this.#handleUpdate(name, value, true, ... args);
	}

	update(name, value) {
		return this.#handleUpdate(name, value, false);
	}

	reset(name = null) {
		if (!name) {
			for (const key of Object.keys(this.#elements)) {
				this.reset(key);
			}
			return;
		}

		const list = this.#elements[ name ];
		const multiple = !!+list.dataset.multiple;
		const defaults = list.dataset.default;

		return this.update(name, multiple ? defaults.split(',') : defaults);
	}

	async toggle(name, value) {
		let current = this.get(name);

		if (current.includes(value)) {
			current = current.filter(currentVal => currentVal !== value);
		} else {
			current.push(value);
		}

		await this.set(name, current);
	}

	#handleUpdate(name, value, callback = true, ... args) {
		const prevValue = this.get(name);

		const list = this.#elements[ name ];
		const multiple = !!+list.dataset.multiple;
		const title = list.querySelector('.dropdown-toggle');
		const items = list.querySelectorAll('li');

		if (multiple) {
			if (!_.isArray(value)) {
				value = value.split(',');
			}

			prevValue.sort();
			value.sort();

			value = _.uniq(value);
		}

		super.store(name, value);

		for (const li of items) {
			if (multiple) {
				li.classList.toggle('active', value.includes(li.dataset.value));
			} else {
				li.classList.toggle('active', value === li.dataset.value);

				if (value === li.dataset.value) {
					title.textContent = li.textContent;
				}
			}
		}

		const changed = !_.isEqual(value, prevValue);

		super.runCallback(name, 'update', ... args);

		if (callback) {
			super.runCallback(name, 'set', ... args);
		}

		return changed;
	}
}

function init(container) {
	return new OptionLists(container);
}

export default { init };
